import { autoserialize, autoserializeAs } from 'cerialize';

import { BaseDTO, IBaseDTO } from './base-dto';
import { IItemMeta, ItemMeta } from './item-meta';
import { ISpecification, Specification } from './specification';

export class CustomItem extends BaseDTO implements ICustomItem {
  @autoserialize id?: string;
  @autoserializeAs('created_at') createdAt?: string;
  @autoserializeAs('discarded_at') discardedAt?: string | null;
  @autoserializeAs('source_item_id') sourceItemId?: string;
  @autoserialize approved?: boolean;
  @autoserialize override name: string;
  @autoserialize description?: string;
  @autoserializeAs(Specification, 'specification') specification: Specification;
  @autoserialize width?: number;
  @autoserialize height?: number;
  @autoserialize depth?: number;
  @autoserialize volume?: number;
  @autoserializeAs(ItemMeta, 'meta') meta?: ItemMeta | null;

  constructor(payload?: ICustomItem) {
    super(payload);
    this.id = payload?.id?.toString();
    this.specification = new Specification(payload?.specification);
    this.createdAt = payload?.createdAt;
    this.discardedAt = payload?.discardedAt;
    this.sourceItemId = payload?.sourceItemId?.toString();
    this.approved = payload?.approved;
    this.name = payload?.name;
    this.description = payload?.description;
    this.width = payload?.width || 0;
    this.height = payload?.height || 0;
    this.depth = payload?.depth || 0;
    this.volume = payload?.volume || 0;
    this.meta = new ItemMeta(payload?.meta);
  }
}

export interface ICustomItem extends IBaseDTO {
  id?: string;
  createdAt?: string;
  discardedAt?: string;
  sourceItemId?: string;
  approved?: boolean;
  name: string;
  description?: string;
  specification: ISpecification;
  width?: number;
  height?: number;
  depth?: number;
  volume?: number;
  meta?: IItemMeta | null;
}
